export default __webpack_public_path__ + "static/media/gift.efb3a4ce.svg";